<template>
  <div class="container" id="top-page">
    <v-expansion-panels multiple v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="Header"
          >Memo List</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search1"
          />
          <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate1" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate1" class="input_date" />
            </div>
          </div>
          <br />
          <v-data-table
            v-if="headerItemsFilterDate.length <= 0"
            item-key="name"
            class="elevation-1 table-header"
            loading
            :items-per-page="5"
            :headers="headersNotfound"
            :items="itemNotfound"
            loading-text="Loading... Please wait"
          ></v-data-table>
          <v-data-table
            v-else
            :items-per-page="5"
            :headers="memo"
            :items="headerItemsFilterDate"
            class="elevation-1 table-header"
          >
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
// import tableComponent from "../table/tableComponent.vue";
import { mapGetters } from "vuex";
import DecodeJWT from "../DecodeJWT";

export default {
  // components: { tableComponent },
  mounted() {
    let token = localStorage.getItem("token");
    if (token == "" || !token) {
      this.$router.push("/login");
    } else {
      var info = DecodeJWT(token);
      if (info.exp <= new Date().getTime() / 1000) {
        this.$router.push("/login");
      } else {
        window.scrollTo({
          top: document.getElementById("top-page").offsetTop,
          left: 0,
          behavior: "smooth",
        });
        this.panel = Array.from(Array(2).keys());
        this.getBAQMemo();
        const today = new Date();
        const fromday = new Date();
        fromday.setMonth(fromday.getMonth() - 3);
        let year = today.getFullYear();
        let month = (today.getMonth() + 1).toString().padStart(2, "0");
        let day = today.getDate().toString().padStart(2, "0");
        this.todate1 = this.todate2 = `${year}-${month}-${day}`;
        year = fromday.getFullYear();
        month = (fromday.getMonth() + 1).toString().padStart(2, "0");
        day = fromday.getDate().toString().padStart(2, "0");
        this.fromdate1 = this.fromdate2 = `${year}-${month}-${day}`;
      }
    }
  },
  data() {
    return {
      headersNotfound: [{ text: "", value: "nf" }],
      itemNotfound: [{ nf: "Data not found!" }],
      memo: [
        { text: "Date", value: "Memo_MemoDate" },
        { text: "Time", value: "Memo_MemoTime" },
        { text: "MemoNum", value: "Memo_MemoNum" },
        { text: "Memo Description", value: "Memo_MemoDesc" },
        { text: "MemoText", value: "Memo_MemoText" },
        { text: "Category", value: "MemoCat_Description" },
        { text: "User ID", value: "Memo_MemoUserID" },
        { text: "Notify", value: "Memo_Notify" },
        { text: "Notify User ID", value: "Memo_NotifyUserID" },
        { text: "Notify Date", value: "Memo_NotifyDate" },
      ],
      shipDetail: [
        { text: "Line", value: "ShipDtl_PackLine" },
        { text: "Order", value: "Calculated_Order" },
        { text: "Complete", value: "ShipDtl_ShipCmpl" },
        { text: "Part", value: "ShipDtl_PartNum" },
        { text: "Track Lots", value: "Part_TrackLots" },
        { text: "Track Serial", value: "Part_TrackSerialNum" },
        { text: "Line Description", value: "ShipDtl_LineDesc" },
        { text: "Warehouse", value: "ShipDtl_WarehouseCode" },
        { text: "Bin", value: "ShipDtl_BinNum", class: "min-width2" },
        { text: "Lot", value: "ShipDtl_LotNum" },
        { text: "Ship Qty", value: "ShipDtl_SellingInventoryShipQty" },
        { text: "Job Qty", value: "ShipDtl_SellingJobShipQty" },
        { text: "Job Lot", value: "ShipDtl_JobLotNum" },
        { text: "UOM", value: "ShipDtl_IUM" },
        { text: "Rev", value: "ShipDtl_RevisionNum" },
        { text: "Qty from Inv", value: "ShipDtl_OurInventoryShipQty" },
        { text: "Job Ship Qty", value: "ShipDtl_OurJobShipQty" },
        { text: "Selling Requested Qty", value: "OrderRel_SellingReqQty" },
        { text: "RemainQty", value: "Calculated_RemainQty" },
        { text: "ShippedQty", value: "Calculated_ShippedQty" },
      ],
      headerItems: [],
      detailItems: [],
      panel: [],
      curShip: {},
      search1: "",
      search2: "",
      fromdate1: "",
      todate1: "",
      fromdate2: "",
      todate2: "",
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    getMemo() {
      this.loadHeader();
    },
  },
  computed: {
    ...mapGetters("User", ["getUserInfo"]),
    ...mapGetters("Data", ["getMemo"]),
    headerItemsFilter() {
      const filterKey = (this.search1 || "").toLowerCase();
      if (this.headerItems == null || filterKey === "") return this.headerItems;
      return this.headerItems.filter((i) => {
        return i.Memo_MemoNum.toString().toLowerCase().indexOf(filterKey) > -1;
      });
    },
    headerItemsFilterDate() {
      if (this.headerItemsFilter.length > 0) {
        let from = new Date(this.fromdate1);
        let to = new Date(this.todate1);
        return this.headerItemsFilter.filter((i) => {
          let day = i.Memo_MemoDate.split("/")[0];
          let month = i.Memo_MemoDate.split("/")[1];
          let year = i.Memo_MemoDate.split("/")[2];
          let date = new Date(year, month - 1, day);
          return date <= to && from <= date;
        });
      } else {
        return this.headerItemsFilter;
      }
    },
  },
  methods: {
    convertDate(stringdate) {
      if (stringdate) {
        var dateObject = new Date(stringdate);
        var day = dateObject.getDate().toString().padStart(2, "0");
        var month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
        var year = dateObject.getFullYear();
        return `${day}/${month}/${year}`;
      } else return "";
    },
    converDateAndTime(stringdatetime) {
      const [dateStr, timeStr] = stringdatetime.split("T");

      // Extracting the formatted date
      const dateObj = new Date(dateStr);
      const formattedDate = dateObj.toLocaleDateString("en-US");

      // Extracting the formatted time
      const timeObj = new Date(`1970-01-01T${timeStr}Z`);
      const formattedTime = timeObj.toTimeString().slice(0, 8);

      return {
        formattedDate,
        formattedTime,
      };
    },
    async getBAQMemo() {
      await this.$store.dispatch("Data/getMemoData");
      this.loadHeader();
    },
    loadHeader() {
      this.headerItems = [];
      if (this.getShipHead && this.getShipHead.length > 0) {
        this.getShipHead.forEach((el) => {
          this.headerItems.push({
            Memo_MemoDate: this.converDateAndTime(el.Memo_MemoDate)
              .formattedDate,
            Memo_MemoTime: this.converDateAndTime(el.Memo_MemoDate)
              .formattedTime,
            Memo_MemoNum: el.Memo_MemoNum,
            Memo_MemoDesc: el.Memo_MemoDesc,
            Memo_MemoText: el.Memo_MemoText,
            MemoCat_Description: el.MemoCat_Description,
            Memo_MemoUserID: el.Memo_MemoUserID,
            Memo_Notify: el.Memo_Notify,
            Memo_NotifyUserID: el.Memo_NotifyUserID,
            Memo_NotifyDate: el.Memo_NotifyDate,
          });
        });
      }
    },
  },
};
</script>

<style scoped>
.ml-20 {
  margin-left: 100px;
}
.input_date {
  outline: #d1dfe3;
}
.filter_date {
  display: flex;
  flex-direction: row;
}
.filter_date_item {
  display: flex;
  flex-direction: column;
}
.mb-20 {
  margin-bottom: 50px;
}
.Header {
  font-weight: 700;
  font-size: 1.2em;
  color: white;
  background-color: #d1dfe3;
  color: black;
}
.table-custom {
  width: 100%;
  margin-top: 20px;
}

table,
th,
td {
  border: 1px solid #ddd;
  height: 50px;
  border-collapse: collapse;
}
th {
  border-bottom: 2px solid black;
}
td {
  text-align: center;
}
.input-search {
  margin-top: 5px;
  margin-bottom: 10px;
  outline: #d1dfe3;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #ddd;
}
.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}

.switchTabMsg {
  text-align: center;
  width: fit-content;
  color: black !important;
  text-decoration: underline;
}

.passwordRules {
  margin-top: -25px;
  margin-left: 15px;
  font-size: small;
  opacity: 0.6;
}
</style>
